var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }, {
      key: "foot",
      fn: function () {
        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "error",
            "outlined": ""
          },
          on: {
            "click": _vm.init
          }
        }, 'v-btn', {
          loading: _vm.loading
        }, false), [_c('span', [_vm._v("초기화")])]), _c('v-btn', _vm._b({
          attrs: {
            "color": "primary"
          },
          on: {
            "click": _vm.save
          }
        }, 'v-btn', {
          loading: _vm.loading
        }, false), [_c('span', [_vm._v("저장하기")])])];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'bottom-sheet', {
    title: _vm.title
  }, false), [_c('form-wrap', {
    attrs: {
      "value": _vm.form
    },
    on: {
      "input": _vm.emit
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }